import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutTwo from "../layouts/LayoutTwo";
import BreadcrumbContact from "../components/breadcrumbs/BreadcrumbContact";
import ContactMap from "../components/contact-maps/ContactMap";

const Contact = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>PIPS | Contact</title>
        <meta name="description" content="Contact page of The Pips" />
      </MetaTags>
      <LayoutTwo theme="blue">
        {/* breadcrumb */}
        <BreadcrumbContact title="CONTACT" />
        {/* contact page content */}
        <section className="conact__area pt--140">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="contact__title">
                  <img
                    src={process.env.PUBLIC_URL + "/images/contact/contact.png"}
                    alt="conatct images"
                  />
                  <h2>Contact Our Team</h2>
                  <p className="color-white">
                    Our global support team is available 24/7, ensuring that no
                    matter where you are or when you trade, expert help is
                    always within reach.
                  </p>
                </div>

                <div className="contact__cards row justify-content-center mt-5">
                  {/* Call Us */}
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="contact__card">
                      <div className="icon">
                        <i className="ti-headphone-alt" />
                      </div>
                      <h4>Call Us</h4>
                      <p>
                        Info: +61 248231230 <br />
                        Support: +61 248231231 <br />
                        Compliance: +61 248231232
                      </p>
                    </div>
                  </div>

                  {/* Email Inquiries */}
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="contact__card">
                      <div className="icon">
                        <i className="ti-email" />
                      </div>
                      <h4>Email Inquiries</h4>
                      <p>
                        info@thetrademasters.com <br />
                        support@thetrademasters.com <br />
                        compliance@thetrademasters.com
                      </p>
                    </div>
                  </div>

                  {/* Our Office */}
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="contact__card">
                      <div className="icon">
                        <i className="ti-location-pin" />
                      </div>
                      <h4>Our Office</h4>
                      <p>
                        17 Hanover Square, London W1S 1BN <br />
                        United Kingdom
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 col-12">
                <div className="google__map">
                  {/* contact map */}
                  <ContactMap latitude="47.444" longitude="-122.176" />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-12 sm__mt--40 md__mt--40">
                <div className="dg__contact__wrapper">
                  <form className="contact-form">
                    <div className="single-contact-form">
                      <span>Full Name</span>
                      <input type="text" name="firstname" />
                    </div>
                    <div className="single-contact-form">
                      <span>Email</span>
                      <input type="email" name="email" />
                    </div>
                    <div className="single-contact-form">
                      <span>Subject</span>
                      <input type="text" name="subject" />
                    </div>
                    <div className="single-contact-form message">
                      <span>Message</span>
                      <textarea name="message" defaultValue={""} />
                    </div>
                    <div className="contact-btn">
                      <button type="submit">
                        Submit
                        <span className="ti-arrow-right" />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </LayoutTwo>
    </Fragment>
  );
};

export default Contact;
